export const host =
  window.location.hostname === 'localhost'
    ? 'http://localhost:8080'
    : window.location.origin;
